import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type HypoMinimizerSuspendPayload = {};

export type HypoMinimizerSuspendEvent = {};

const hypoMinimizerSuspendSchema = z.object({});

export const LID_HYPO_MINIMIZER_SUSPEND = {
  value: 0xc6,
  name: "Hypo Minimizer Suspend",
  format: "................",
  fields: [],
  postprocess: () => ({}),
  schema: hypoMinimizerSuspendSchema,
} as const satisfies TandemEventDefinition<HypoMinimizerSuspendPayload, HypoMinimizerSuspendEvent>;
